import { render, staticRenderFns } from "./ChallengeCountdown.vue?vue&type=template&id=38f03ab4"
import script from "./ChallengeCountdown.vue?vue&type=script&lang=ts"
export * from "./ChallengeCountdown.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeCountdown.vue?vue&type=style&index=0&id=38f03ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports